import { Navigate, useLocation } from 'react-router';

/**
 * `/schedules` folded into `/classes` (THI-267 — "Thời khóa biểu" -> "Lớp
 * học", spec §5). `/schedules` only ever showed the weekly grid, so the
 * redirect pins `?tab=grid` — a bookmarked or shared `?template=x` deep link
 * (schedule templates open through the same query param) lands on
 * `/classes?tab=grid&template=x`, never on whichever tab a browser's
 * localStorage happened to remember last.
 */
export function SchedulesRedirect() {
  const location = useLocation();
  const incoming = new URLSearchParams(location.search);
  const params = new URLSearchParams();
  params.set('tab', 'grid');
  for (const [key, value] of incoming) {
    if (key === 'tab') continue; // grid is the only view /schedules ever had
    params.set(key, value);
  }
  return <Navigate to={{ pathname: '/classes', search: `?${params.toString()}` }} replace />;
}
